export const AUTHORITY_TYPE = {
    INSTALLER: 'Installer',
};
